<template>
  <div class="home">
    <v-img
      :src="require('@/assets/red_blank.jpg')"
      :gradient="'to bottom, ' + hexToRGBATop(config.primary) + ', ' + hexToRGBABottom(config.footer)"
      height="600"
    >
      <v-row style="margin-top: 180px;" justify="center" class="lightbox white--text fill-height">
        <v-col cols="12" sm="10">
          <div class="display-2 mb-5">Chipcustomizer Designer</div>
          <div class="headline">Here you can create and share your very own customized chips to print on your label sheets.</div>
          <div class="headline mt-5 mb-5">Start designing now!</div>
          <div class="display-2 mt-5 mb-5">
            <v-btn @click="navigateTo('register')" large elevation="5" :dark="config.dark_secondary" v-if="!loggedIn" class="mr-5">
              <v-icon left>mdi-account-plus</v-icon>
              <span>Sign Up</span>
            </v-btn>
            <v-btn @click="navigateTo('login')" large elevation="5" :dark="config.dark_secondary" v-if="!loggedIn" class="mr-5">
              <v-icon left>mdi-login</v-icon>
              <span>Login</span>
            </v-btn>
            <v-btn @click="navigateTo('create')" large elevation="5" :dark="config.dark_secondary" v-if="loggedIn" class="mr-5">
              <v-icon left>mdi-circle-edit-outline</v-icon>
              <span>Create</span>
            </v-btn>
            <v-btn @click="navigateTo('browse')" large elevation="5" :dark="config.dark_secondary" v-if="loggedIn" class="mr-5">
              <v-icon left>mdi-cart</v-icon>
              <span>Browse</span>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-img>
    <v-card
    tile
    :color="config.footer"
    :dark="config.dark_footer"
    width="100%"
    height="100%"
    >
      <v-spacer style="height:120px"></v-spacer>
      <v-container>
        <v-row justify="center">
          <v-card max-width="1000px" :color="config.background_dark">
            <v-carousel
              cycle
              height="auto"
              hide-delimiter-background
              show-arrows-on-hover
            >
              <v-carousel-item
                eager
                v-for="(slide, i) in slides"
                :key="i"
                style="width: 100%; height: 100%"
                hide-delimiter-background
              >
                <v-img
                  eager
                  :lazy-src="slide.src"
                  :src="slide.src"
                  gradient="to bottom, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.9)"
                >
                  <v-row
                    class="text-content fill-height"
                    align="center"
                    justify="center"
                  >
                    <div class="display-1" justify="center">{{ slide.text }}</div>
                  </v-row>
                </v-img>
              </v-carousel-item>
            </v-carousel>
          </v-card>
        </v-row>
        <v-spacer style="height:200px;"></v-spacer>
        <v-card class="mr-auto ml-auto" max-width="1200px" :color="config.background_dark">
          <v-row justify="center" align="center">
            <v-container style="width:70%;">
              <v-card-title class="font-weight-black text-center display-1 text-break">
              ORDER THE DO IT YOURSELF POKER CHIP LABELING KIT TO CREATE CUSTOM POKER CHIPS!
              </v-card-title>
            </v-container>
          </v-row>
          <v-divider></v-divider>
          <v-container>
            <v-row justify="center">
              <v-col cols="12" sm="3">
                <v-img :src="require('@/assets/chipcustomizer.png')" contain  />
              </v-col>
              <v-col cols="12" sm="3">
                <v-col cols="12" sm="7">
                  <v-img :src="require('@/assets/3chips.png')" contain  />
                </v-col>
                <v-col cols="12" sm="7">
                  <v-img :src="require('@/assets/print.png')" contain  />
                </v-col>
              </v-col>
              <v-col cols="12" sm="3">
                <v-img href="http://chipcustomizer.com" :src="require('@/assets/ordernow.png')" contain  />
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" sm="6">
                <v-card elevation="4" :color="config.background_dark_slight">
                  <v-row justify="center">
                    <div style="width:50%; margin-top:20px;">
                      <v-img :src="require('@/assets/mbg.png')" contain  />
                    </div>
                  </v-row>
                  <v-card-title class="text-break">
                    That's right, we stand behind our product 100% and if there is any reason what so ever that you are not satisfied with our product, we will give you your money back. You have absolutely no risk in trying this product out to see how it works. We pride ourselves in customer satisfaction and will personally take care of any issues you may have. Without our customers we know we wouldn't have a business so we make sure we take good care of you.
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6">
                <v-card elevation="4" :color="config.background_dark_slight">
                  <v-row justify="center">
                    <div style="width:50%; margin-top:20px;">
                      <v-img :src="require('@/assets/made-in-usa.png')" contain  />
                    </div>
                  </v-row>
                  <v-card-title class="text-break">
                     Not many products can say this now, but all of the elements of our product are made in the United States. Our software is created by a California based company, our labels are manufactured in the mid west, our label placement tool is produced in Chatsworth, CA and even our packaging is made in the states.
                  </v-card-title>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
          <v-container class="mt-4">
            <v-row justify="center">
              <v-col cols="12" sm="4">
                <v-container>
                  <v-card elevation="4" :color="config.background_dark_slight">
                    <v-card-title>
                      <v-icon left>mdi-circle-edit-outline</v-icon>
                      Design
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      Using the built-in web application, design your own masterfully crafted chip. The app comes with tons of backgrands and out of the box templates to make it simple and easy to create the design you want. Use the templates or create your own design using your pictures and logos.
                    </v-card-text>
                  </v-card>
                </v-container>
              </v-col>
              <v-col cols="12" sm="4">
                <v-container>
                  <v-card elevation="4" :color="config.background_dark_slight">
                    <v-card-title>
                      <v-icon left>mdi-printer</v-icon>
                      Print
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        Print your newly created design on the included photo quality chip labels. Print just one or as many as you want at once. The included 700 photo quality labels let you print using your printers high quality setting giving you great looking images for your custom poker chips.
                    </v-card-text>
                  </v-card>
                </v-container>
              </v-col>
              <v-col cols="12" sm="4">
                <v-container>
                  <v-card elevation="4" :color="config.background_dark_slight">
                    <v-card-title>
                      <v-icon left>mdi-circle-edit-outline</v-icon>
                      Stick
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        Slip a poker chip into the included label placement tool to easily center your label on your poker chip. Not only could you create awesome looking casino style poker chips for your own home poker games, but you can also create fun coupons for your business, giveaways for special events and more.
                    </v-card-text>
                  </v-card>
                </v-container>
              </v-col>
            </v-row>
            <v-spacer style="height:100px; width:100%;" />
            <v-row justify="center">
              <v-btn href="http://chipcustomizer.com" x-large :color="config.primary">
                <v-icon left>mdi-cart</v-icon>
                View purchasing options
              </v-btn>
            </v-row>
            <v-spacer style="height:100px; width:100%;" />
          </v-container>
        </v-card>
      </v-container>
      <v-spacer style="height:300px;" />
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src
import config from '@/config/config'
import { mapGetters } from 'vuex'

export default {
  name: 'home',
  data () {
    return {
      config,
      colors: [
        'indigo',
        'warning',
        'pink darken-2',
        'red lighten-1',
        'deep-purple accent-4',
      ],
      slides: [
        {text: 'Create you very own chip, completely online!', src: require('@/assets/slide1.jpg')},
        {text: 'Share what you create and find inspiration from others!', src: require('@/assets/slide2.jpg')},
        {text: 'You can save your favorite chips to your library so you never loose them!', src: require('@/assets/slide3.jpg')}
      ],
    }
  },
  methods: {
    navigateTo (route) {
      this.$router.push(route)
    },
    hexToRGBATop(hex) {
      var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);
      const a = 0.0
      return `rgba(${r},${g},${b},${a})`
    },
    hexToRGBABottom(hex) {
      var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);
      const a = 1.0
      return `rgba(${r},${g},${b},${a})`
    },
  },
  computed: {
    ...mapGetters({
      loggedIn: 'loggedIn',
      getSearchInfo: 'getSearchInfo',
      getUser: 'getUser'
    })
  }
}
</script>

<style scoped>
  .home {
    background: rgb(36, 36, 36);
  }

  .text-content {
    margin-top: 180px;
    margin-left: auto;
    margin-right: auto;
    justify-content: center;
    text-align: center;
    width: 80%;
    height:100%;
  }



  .flex-container {
    height: 1200px;
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
  }

  .flex-item {
    width: 80%;
    height: auto;
    order: 0;
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: auto;
    margin-top: 70px;
    padding: 18px;
  }

  .flex-item-main {
    width: auto;
    height: auto;
    order: 0;
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: auto;
    margin-top: 70px;
    padding: 18px;
  }
</style>
